/** Filter + map legend: API `status` query values and i18n label keys. */
export const ATTENDANCE_HISTORY_STATUS_FILTERS = [
  { key: "PRESENT", value: "PRESENT", labelKey: "attendanceFilter.historyStatuses.PRESENT" },
  { key: "EARLY_CLOCK_IN", value: "EARLY_CLOCK_IN", labelKey: "attendanceFilter.historyStatuses.EARLY_CLOCK_IN" },
  { key: "LATE_ARRIVAL", value: "LATE_ARRIVAL", labelKey: "attendanceFilter.historyStatuses.LATE_ARRIVAL" },
  { key: "BREAK_START", value: "BREAK_START", labelKey: "attendanceFilter.historyStatuses.BREAK_START" },
  { key: "BREAK_END", value: "BREAK_END", labelKey: "attendanceFilter.historyStatuses.BREAK_END" },
  { key: "ABSENT", value: "ABSENT", labelKey: "attendanceFilter.historyStatuses.ABSENT" },

  { key: "EARLY_OUT", value: "EARLY_OUT", labelKey: "attendanceFilter.historyStatuses.EARLY_OUT" },
  { key: "LATE_AND_EARLY_OUT", value: "LATE_AND_EARLY_OUT", labelKey: "attendanceFilter.historyStatuses.LATE_AND_EARLY_OUT" },
  { key: "HAS_ISSUES", value: "HAS_ISSUES", labelKey: "attendanceFilter.historyStatuses.HAS_ISSUES" },
  { key: "HALF_DAY", value: "HALF_DAY", labelKey: "attendanceFilter.historyStatuses.HALF_DAY" },
  // { key: "OVERTIME", value: "OVERTIME", labelKey: "attendanceFilter.historyStatuses.OVERTIME" },
];

/** Map tab only — punch-level legend rows (counts use pin status, not day row status) */
export const ATTENDANCE_HISTORY_MAP_PUNCH_LEGEND = [


];

/** Full map legend: day-level filters + punch-level items */
export const ATTENDANCE_HISTORY_MAP_LEGEND = [
  ...ATTENDANCE_HISTORY_STATUS_FILTERS,
  ...ATTENDANCE_HISTORY_MAP_PUNCH_LEGEND,
];

export const attendanceHistoryStatusLabelKeyByValue = Object.fromEntries(
  ATTENDANCE_HISTORY_STATUS_FILTERS.map((o) => [o.value, o.labelKey])
);

/**
 * Maps attendance-history API/filter values to `statusPalette` keys (product colors).
 * History uses LATE_ARRIVAL etc.; palette product colors use LATE_CLOCK_IN, EARLY_CLOCK_OUT, etc.
 */
export const ATTENDANCE_HISTORY_STATUS_COLOR_KEY = {
  PRESENT: "PRESENT",
  ABSENT: "ABSENT",
  LATE_ARRIVAL: "LATE_CLOCK_IN",
  EARLY_OUT: "EARLY_CLOCK_OUT",
  LATE_AND_EARLY_OUT: "LATE_CLOCK_OUT",
  HAS_ISSUES: "unvalidated",
  HALF_DAY: "HALF_DAY",
  OVERTIME: "LATE_CLOCK_OUT",
  EARLY_CLOCK_IN: "EARLY_CLOCK_IN",
  BREAK_START: "BREAK_START",
  BREAK_END: "BREAK_END",
  ON_BREAK: "BREAK_START",
};

/** Table/drawer row status strings from API → palette keys */
const ATTENDANCE_HISTORY_DISPLAY_COLOR_KEY = {
  Present: "PRESENT",
  present: "PRESENT",
  PRESENT: "PRESENT",
  "Early Out": "EARLY_CLOCK_OUT",
  "early out": "EARLY_CLOCK_OUT",
  "EARLY OUT": "EARLY_CLOCK_OUT",
  EARLY_OUT: "EARLY_CLOCK_OUT",
  earlyOut: "EARLY_CLOCK_OUT",
  earlyout: "EARLY_CLOCK_OUT",
  "Late Arrival": "LATE_CLOCK_IN",
  "late arrival": "LATE_CLOCK_IN",
  "LATE ARRIVAL": "LATE_CLOCK_IN",
  LATE_ARRIVAL: "LATE_CLOCK_IN",
  lateArrival: "LATE_CLOCK_IN",
  latearrival: "LATE_CLOCK_IN",
  "Late And Early Out": "LATE_CLOCK_OUT",
  "late and early out": "LATE_CLOCK_OUT",
  "LATE AND EARLY OUT": "LATE_CLOCK_OUT",
  LATE_AND_EARLY_OUT: "LATE_CLOCK_OUT",
  lateAndEarlyOut: "LATE_CLOCK_OUT",
  lateandearlyout: "LATE_CLOCK_OUT",
  "Has Issues": "unvalidated",
  "has issues": "unvalidated",
  "HAS ISSUES": "unvalidated",
  HAS_ISSUES: "unvalidated",
  hasIssues: "unvalidated",
  hasissues: "unvalidated",
  "Half Day": "HALF_DAY",
  "half day": "HALF_DAY",
  "HALF DAY": "HALF_DAY",
  HALF_DAY: "HALF_DAY",
  halfDay: "HALF_DAY",
  halfday: "HALF_DAY",
  Overtime: "LATE_CLOCK_OUT",
  overtime: "LATE_CLOCK_OUT",
  OVERTIME: "LATE_CLOCK_OUT",
  Absent: "ABSENT",
  absent: "ABSENT",
  ABSENT: "ABSENT",
};

/** Resolve history status → palette key for badges, legend dots, and chips */
export function getAttendanceHistoryColorKey(status) {
  if (status == null || status === "") return "";
  const raw = String(status).trim();
  if (ATTENDANCE_HISTORY_DISPLAY_COLOR_KEY[raw]) {
    return ATTENDANCE_HISTORY_DISPLAY_COLOR_KEY[raw];
  }
  const normalized = raw.toUpperCase().replace(/\s+/g, "_").replace(/-/g, "_");
  if (ATTENDANCE_HISTORY_STATUS_COLOR_KEY[normalized]) {
    return ATTENDANCE_HISTORY_STATUS_COLOR_KEY[normalized];
  }
  return raw;
}
